var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCopyActivity = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8008 7.375H9.05078C8.22235 7.375 7.55078 8.04657 7.55078 8.875V15.625C7.55078 16.4534 8.22235 17.125 9.05078 17.125H15.8008C16.6292 17.125 17.3008 16.4534 17.3008 15.625V8.875C17.3008 8.04657 16.6292 7.375 15.8008 7.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55078 11.875H3.80078C3.40296 11.875 3.02143 11.717 2.74012 11.4357C2.45882 11.1544 2.30078 10.7728 2.30078 10.375V3.625C2.30078 3.22718 2.45882 2.84564 2.74012 2.56434C3.02143 2.28304 3.40296 2.125 3.80078 2.125H10.5508C10.9486 2.125 11.3301 2.28304 11.6114 2.56434C11.8927 2.84564 12.0508 3.22718 12.0508 3.625V4.375",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopyActivity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copyActivity.848cb723.svg";
export { ForwardRef as ReactComponent };